import * as React from "react";
const SvgArrowRight20 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M11.263 3.953a.75.75 0 0 0-1.06 1.06l4.236 4.237H3.75a.75.75 0 0 0 0 1.5h10.69l-4.238 4.238a.75.75 0 0 0 1.06 1.06l5.518-5.517a.75.75 0 0 0 0-1.06l-5.517-5.518Z" }));
const ForwardRef = React.forwardRef(SvgArrowRight20);
export default ForwardRef;
